import React from "react";
import { RoleManageContextProvider } from "./RoleListView";
import RoleList from "./views/RoleList";

const RoleManageListPage = () => {
  return (
    <div>
      <RoleManageContextProvider>
        <RoleList />
      </RoleManageContextProvider>
    </div>
  );
};

export default RoleManageListPage;
